import { Container } from 'react-bootstrap';

import optainScanningImg from 'src/assets/img/optain-scanning.png';

import useUiTranslation from 'src/hooks/useUiTranslation';

interface ImagingInProgressProps {
  id?: string;
  onDragOver?: React.DragEventHandler<HTMLImageElement>;
  onDrop?: React.DragEventHandler<HTMLImageElement>;
}

const ImagingInProgress = ({
  id,
  onDragOver,
  onDrop,
}: ImagingInProgressProps) => {
  const { tPages } = useUiTranslation();
  return (
    <Container className="position-relative p-0 border-0">
      <img
        src={optainScanningImg}
        alt={tPages('newExam.imagingInProgress')}
        className="img-fluid"
        style={{
          width: '4096px',
          maxHeight: window.innerWidth > 2000 ? '60vh' : '43vh',
          objectFit: 'contain',
        }}
        id={id}
        onDragOver={onDragOver}
        onDrop={onDrop}
        draggable={false}
      />

      <div
        className="position-absolute start-50 translate-middle text-white text-center pe-none"
        style={{ top: '60%' }}
      >
        {tPages('newExam.imagingInProgress')}
      </div>
    </Container>
  );
};
export default ImagingInProgress;
